import React, { useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import CustomGreenButton from '../../../UI/Intro/customButton/customGreenButton';
import './Pricing.css';
import { Snackbar, Alert } from '@mui/material';
import { useContactUsMutation } from '../../../store/services/other/other';
import HighlightCard from '../../../UI/HighlightCard/HighlightCard';
import PricingCalculator from '../../PricingCalculator';

const Pricing = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.2 });

    // Contact form and snackbar state
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [contactUs] = useContactUsMutation();

    const handleOpen = () => setIsModalOpen(true);
    const handleClose = () => setIsModalOpen(false);
    const handleSnackbarClose = () => setOpenSnackbar(false);
    const handleSendEmail = async (emailData) => {
        try {
            const response = await contactUs(emailData).unwrap();
            if (response.message === 'success') {
                setSnackbarMessage('Email sent successfully!');
                setSnackbarSeverity('success');
            }
        } catch (error) {
            setSnackbarMessage('An error occurred!');
            setSnackbarSeverity('error');
            handleClose();
        }
        setOpenSnackbar(true);
    };

    return (
        <div ref={ref} className="pricing-section">
            <motion.div
                className="pricing-cards-row"
                initial={{ opacity: 0, y: 60 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, ease: 'easeOut' }}
            >
                <HighlightCard width="340px" height="330px">
                    <div className="pricing-card-content-payg">
                        <div className="pricing-title-1">Free trial</div>
                        <div className="pricing-subtitle-1">Try any tool free</div>
                        <div className="pricing-desc-1">You'll get 500 credits to use every month</div>
                    </div>
                </HighlightCard>

                <HighlightCard width="340px" height="330px">
                    <div className="pricing-card-content-payg">
                        <div className="pricing-title-2">Pay–as–You–Go</div>
                        <div className="pricing-subtitle-1">$5</div>
                        <div className="pricing-desc-2">for additional 500 credits</div>
                    </div>
                </HighlightCard>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 60 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, ease: 'easeOut', delay: 0.4 }}
            >
                <HighlightCard handleOpen={handleOpen} >
                    <span className="enterprise-title">Enterprise Plan</span>
                    <div className="vertical-divider">
                        <svg xmlns="http://www.w3.org/2000/svg" width="2" height="122" viewBox="0 0 2 122" fill="none">
                            <path d="M1 122L1.00001 -3.36766e-06" stroke="url(#paint0_radial_229_1225)" />
                            <defs>
                                <radialGradient id="paint0_radial_229_1225" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(0.0360789 208.36) rotate(-89.6568) scale(527.077 30.5624)">
                                    <stop stopColor="#040209" />
                                    <stop offset="1" stopColor="#00FD8E" />
                                </radialGradient>
                            </defs>
                        </svg>
                    </div>
                    <span className="enterprise-desc">Custom pricing for teams and organizations</span>
                    <CustomGreenButton width="170px" firstText="Pricing Calculator" secondText="Pricing Calculator" handleClick={handleOpen} />
                </HighlightCard>
            </motion.div>

            <PricingCalculator
                open={isModalOpen}
                handleClose={handleClose}
            />
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Pricing;
